import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './LegalPage.css';

function LegalPage({ title, content }) {
  const { t } = useTranslation();

  return (
    <div className="legal-page">
      <div className="legal-header">
        <div className="container">
          <h1>{title}</h1>
          <p>{t('legal.lastUpdated')}</p>
        </div>
      </div>

      <div className="container">
        <div className="legal-nav">
          <Link to="/eula">{t('footer.eula')}</Link>
          <Link to="/privacy">{t('footer.privacy')}</Link>
          <Link to="/terms">{t('footer.terms')}</Link>
        </div>

        <div className="legal-content">
          {content}
          <Link to="/" className="back-btn">{t('legal.backHome')}</Link>
        </div>
      </div>
    </div>
  );
}

export default LegalPage;
